import { DeleteOutlined } from '@ant-design/icons';
import { Form, message } from 'antd';
import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import componentsStore from '../../../../stores/componentsStore';
import homeStore from '../../../../stores/homeStore';
import productStore from '../../../../stores/productStore';
import ContentBox from '../../../molecules/ContentBox';
import { MobileIcon, WebIcon } from '../../../molecules/IconComponent';
import BannerFull from '../../../organisms/ComponentesHome/BannerFull';
import BlogComponent from '../../../organisms/ComponentesHome/BlogComponent';
import BranchComponent from '../../../organisms/ComponentesHome/BranchComponent';
import CategoryCarrosel from '../../../organisms/ComponentesHome/CategoryCarrosel';
import ImagemHomeComponent from '../../../organisms/ComponentesHome/ImagemHomeComponent';
import SlideShowPrincipal from '../../../organisms/ComponentesHome/SlideShowPrincipal';
import ProductCarousel from '../../CreateHome/ProductCarousel';
import './styles.scss';

interface ViewHomeFullProps {
    isMobile: boolean;
    setMobile: Dispatch<SetStateAction<boolean>>;
}

const ViewHomeFullKernel: React.FC<ViewHomeFullProps> = observer(({ setMobile, isMobile }) => {
    const { componentsList } = componentsStore;
    const [productsByCategory, setProductsByCategory] = useState<{ [key: string]: any[] }>({});
    const [hoverElement, setHoverElement] = useState();
    const [loading, setLoading] = useState(false);

    const fetchCategoryProducts = async (categorySlug: string) => {
        if (productsByCategory[categorySlug]) {
            setLoading(false);
            return;
        }

        const result = await productStore.getProductByCategory(categorySlug, productStore.defaultparams);
        if (!result.error) {
            setProductsByCategory(prevState => ({
                ...prevState,
                [categorySlug]: result.data.content,
            }));
        }
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        // Para cada componente do tipo PRODUCT_CAROUSEL, buscamos seus produtos
        componentsList.filter((item: any) => item.type === "PRODUCT_CAROUSEL")
            .forEach((carouselComponent: any) => {
                fetchCategoryProducts(carouselComponent?.component?.category?.slug);
            });
    }, [componentsList]);

    const renderComponent = (component: any) => {
        const bannerTag = component?.banners?.[0]?.tag;

        if (component?.type === "PRODUCT_CAROUSEL" && !component?.category) {
            return <div className="flex justify-center p-8"><p>Componente sem Categoria </p><b className="pl-1">{component.name}</b></div>;
        }

        if (component.type === "PRODUCT_CAROUSEL") {
            const categorySlug = component?.category?.slug;
            return (
                <div className="max-width-view">
                    <ProductCarousel
                        loading={loading}
                        category={component.category}
                        isMobile={isMobile}
                        products={productsByCategory[categorySlug] || []}
                    />
                </div>
            );
        }

        if (component?.banners?.length === 0) {
            return <div className="flex justify-center p-8"><p>Componente sem imagem </p><b className="pl-1">{component.name}</b></div>;
        }

        // Estrutura switch para lidar com diferentes tipos de banners
        switch (bannerTag) {
            case "SLIDESHOW_PRINCIPAL":
                return <SlideShowPrincipal banner={component.banners[0]} isMobile={isMobile} />;
            case "SLIDESHOW":
                return <SlideShowPrincipal banner={component.banners[0]} isMobile={isMobile} />;
            case "IMAGENS_HOME":
                return <ImagemHomeComponent banner={component.banners[0]} isMobile={isMobile} />;
            case "BLOG":
                return <BlogComponent banner={component.banners[0]} isMobile={isMobile} />;
            case "MARCAS":
                return <div className="py-8 max-width-view"><BranchComponent banner={component.banners[0]} isMobile={isMobile} /></div>;
            case "CATEGORY_CAROUSEL":
                return <div className="py-8  max-width-view"><CategoryCarrosel banner={component.banners[0]} isMobile={isMobile} /></div>;
            case "BANNER_FULL":
                return <div className="py-6 "><BannerFull banner={component.banners[0]} /></div>;
            default:
                return null;
        }
    };

    const handleSubmit = (values: any) => {
        const dateFormat = values && values.date && values?.date?.format('YYYY-MM-DD');

        if (dateFormat) {
            const filterDate = new Date(`${dateFormat}T00:00:00.000Z`);
            homeStore.updateFilterComponent(filterDate, isMobile);
        } else {
            message.error('Selecione uma data para filtrar');
        }
    }

    const initialValues = {
        date: '',
    };

    const defaultparams = {
        "size": 20,
        "page": 0,
        "sort": "created,desc",
        "search": ""
    }

    const deleteItem = async (item: any) => {
        const response = await componentsStore.deleteComponente(item.uuid);

        if (!response?.error) {
            await componentsStore.getList(defaultparams);
        }
    }

    return (
        <div>
            <ContentBox className="mb-4 p-4" borderCustom='rounded-b-lg'>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                >
                    {() => (
                        <Form>
                            <div className="flex items-center gap-4 justify-between ">
                                <p className="text-gray-500 dark:text-white text-sm">Visualização de Componentes</p>
                                <div className="flex gap-2">
                                    <div className="flex gap-3">
                                        <div onClick={() => setMobile(true)} className={`p-1.5 px-1.5 flex justify-center items-center cursor-pointer rounded ${isMobile ? 'border-2 border-blue-500' : 'border border-slate-200'}`}>
                                            <MobileIcon />
                                        </div>
                                        <div onClick={() => setMobile(false)} className={`p-1.5 px-1.5 flex justify-center items-center cursor-pointer rounded ${!isMobile ? 'border-2 border-blue-500' : 'border border-slate-200'}`}>
                                            <WebIcon />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>

                <div
                    onMouseLeave={() => setHoverElement(undefined)}
                    style={{ padding: '16px 0px' }}
                >
                    {componentsList.filter((item: any) => item.mobile === isMobile).map((item: any, index: number) => (
                        <div className="container-component"
                            onMouseEnter={() => {
                                setHoverElement(item);
                            }}>
                            {hoverElement === item &&
                                <>
                                    <div className="options-home">
                                        <div className="flex option-list cursor-pointer">
                                            <div>{item.name}</div>
                                            <div onClick={() => deleteItem(item)} className="home-icon"><DeleteOutlined /></div>
                                        </div>
                                    </div>
                                </>
                            }

                            <div className={`${isMobile ? 'mobile-size m-auto p-3' : ''}`}>
                                {renderComponent(item)}
                            </div>
                        </div>
                    ))}
                </div>
            </ContentBox>
        </div>
    );
});

export default ViewHomeFullKernel;